<template>
    <div>
        <div class="user_bor">
            <div class="user_box">
                <div class="user_box_left">
                    {{$t('m.Myorder_01')}}
                </div>
                <div class="user_box_right"></div>
            </div>
            <div class="nav_box">
                <div class="nav_li pointer" v-for="(item, index) in nav_list" :key="index" @click="chang_nav(index)">
                    <span :class="{ Selected_style: item.Selected }">{{ item.text }}</span>
                    <div v-if="item.Selected" class="Underline"></div>
                </div>
            </div>
			<!-- PC版本 -->
            <div class="tableDatabox">
                <el-table :data="tableData">
					<template slot="empty">
						<el-empty :image-size="100" :description="$t('m.new_txt3')"></el-empty>
					</template>
                    <el-table-column min-width="70" :label="$t('m.Myorder_08')" prop="order_sn"></el-table-column>
					<el-table-column min-width="120" :label="$t('m.Myorder_09')" prop="order_goods.goods_name">
						<template slot-scope="scope">
							<slot :row="scope.row" :$index="scope.$index" >
								<p class="line2">{{scope.row.order_goods.goods_name}}</p>
							</slot>
						</template>
					</el-table-column>
                    <el-table-column min-width="160" :label="$t('m.Myorder_10')" prop="order_goods.spec_key_name">
						<template slot-scope="scope">
							<slot :row="scope.row" :$index="scope.$index" >
								<p class="line2">{{scope.row.order_goods.spec_key_name}}</p>
							</slot>
						</template>
                    </el-table-column>
                    <el-table-column min-width="120" :label="$t('m.Myorder_11')" prop="goods_num"></el-table-column>
                    <el-table-column min-width="120" :label="$t('m.PlaceOrder_09')" prop="order_amount_rmb"></el-table-column>
                    <el-table-column min-width="120" :label="$t('m.PlaceOrder_10')" prop="order_amount_dollar"></el-table-column>
                    <el-table-column min-width="90" :label="$t('m.Myorder_12')" prop="add_time"></el-table-column>
                    <el-table-column min-width="90" :label="$t('m.Myorder_13')" prop="order_status"></el-table-column>
                    <el-table-column min-width="82" :label="$t('m.MallCenter_15')">
                        <template slot-scope="scope" class="pointer">
                            <div class="pointer operation">
                                <span class="info pointer" @click="order_info(scope.row.id)">{{$t('m.home_11')}}</span>
                                <span class="line" v-if="scope.row.btn.download">|</span>
                                <span @click="word_down(scope.row.id)" v-if="scope.row.btn.download" class="download pointer">{{$t('m.Myorder_07')}}</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
			<!-- h5的表 -->
			<div class="tableDatabox_h5">
				<!-- 666 -->
				<div class="zw" v-if="!tableData.length">{{$t('m.new_txt3')}}</div>
				
				<!-- 其他信息 -->
				<div class="other_box wow animate__animated animate__fadeInUp" v-for="(item,index) in tableData">
					<p class="tit"></p>
					<div class="item_o">
						<div class="status flex f-ct f-bt">
							<p>-{{$t('m.shoping_txt1')}}</p>
						</div>
						<div class="goods flex">
							<div class="l">
								<img :src="item.order_goods.thumb" alt="">
							</div>
							<div class="r">
								<div class="tbox1 flex f-ct f-bt">
									<p class="line2">{{item.order_goods.goods_name}}</p>
								</div>
								<div class="tbox2 flex f-ct f-bt">
									<p>{{$t('m.Myorder_10')}}：{{item.order_goods.spec_key_name}}</p>
									<p style="opacity: 0;">x1</p>
								</div>
							</div>
						</div>
					</div>
					<div class="item flex f-ct f-bt">
						<p>{{$t('m.Myorder_11')}}</p>
						<p>{{item.goods_num}}</p>
					</div>
					<div class="item flex f-ct f-bt">
						<p>{{$t('m.PlaceOrder_09')}}</p>
						<p>{{item.order_amount_rmb}}</p>
					</div>
					<div class="item flex f-ct f-bt">
						<p>{{$t('m.PlaceOrder_10')}}</p>
						<p>￥{{item.order_amount_dollar}}</p>
					</div>
					<div class="item flex f-ct f-bt">
						<p>{{$t('m.Myorder_12')}}</p>
						<p>${{item.add_time}}</p>
					</div>
					<div class="item flex f-ct f-bt">
						<p>{{$t('m.Myorder_13')}}</p>
						<p>{{item.order_status}}</p>
					</div>
					
					<div class="item flex f-ct f-bt" style="font-size: 0.65rem;font-weight: 600;margin-top: 10px;">
						<p>
							<span class="info pointer" @click="order_info(item.id)">{{$t('m.home_11')}}</span>
							<span class="line" v-if="item.btn.download">|</span>
							<span @click="word_down(scope.row.id)" v-if="item.btn.download" class="download pointer">{{$t('m.Myorder_07')}}</span>
						</p>
					</div>
					
						<!-- 规格部分 -->
					<!-- <div class="ggbox">
						<div class="tit2 flex f-ct f-bt">
							<p>-{{item.goods_spec_name}}</p>
						</div>
						<div class="gg_box" v-for="(gg_item,gg_index) in item.goods_spec_price" :key="gg_index">
							<div class="item_gg1 flex f-ct" @click="changradio(item,gg_index)">
								<div :class="gg_item.Selected?'active':''">
									<img v-if="gg_item.Selected" src="@/static/images/Selected.png" alt="">
									<img v-else src="@/static/images/notSelected.png" alt="">
								</div>
								<p>{{gg_item.name}}</p>
							</div>
							<div class="item_gg2 flex f-ct f-bt">
								<div>
									<div class="pointer btnbox flex f-ct f-btc" @click.stop="reduce(gg_index, item)">
										<span>－</span>
									</div>
									<div class="inpunumber">
									    <el-input v-model="gg_item.num"></el-input>
									</div>
									<div class="pointer btnbox flex f-ct f-btc" @click.stop="add(gg_index, item)">
										<span>＋</span>
									</div>
								</div>
								<p>￥{{gg_item.price_rmb_show}}</p>
								<p>${{gg_item.price_dollar_show}}</p>
							</div>
						</div>
					</div> -->
				</div>	
			</div>
			<!-- 分页 -->
            <div class="pagingbox">
                <div>
                    <el-pagination background layout="prev, pager, next" :current-page="current_page" @current-change="handleCurrentChange"
                        :page-size="page_size" :total="total">
                    </el-pagination>
                </div>
                <div>
                    {{$t('m.MallCenter_04')}}{{ total }}{{$t('m.MallCenter_04')}}
                </div>
            </div>
        </div>
		<a class="downloadUrl" v-show="false" :href="downloadUrl" target="_blank" ref="downloadUrl"></a>
    </div>
</template>
<script>
import encryption from '@/utils/encryption.js'
export default {
    components:{},
    data() {
        return {
            user_id:'',
            total: 0,   //总条数
            page_size: 6,  //每页显示多少条
            current_page: 1,  //当前页
            type:0,         //状态
			downloadUrl:'',
            tableData: [],
            nav_list: [
                {
                    text: this.$t('m.MallCenter_20'),
                    id:0,
                    Selected: true
                },
                {
                    text: this.$t('m.Myorder_02'),
                    id:1,
                    Selected: false
                },
                {
                    text: this.$t('m.Myorder_03'),
                    id:2,
                    Selected: false
                },
                {
                    text: this.$t('m.Myorder_04'),
                    id:3,
                    Selected: false
                },
                {
                    text: this.$t('m.Myorder_05'),
                    id:4,
                    Selected: false
                },
                {
                    text: this.$t('m.Myorder_06'),
                    id:5,
                    Selected: false
                }
            ],
			// H5版本列表
			is_pages:true,
        }
    },
    created() {
		window.addEventListener('scroll', this.Scrollbottom);  //页面加载时监听滚动事件
    },
	destroyed() {
		window.removeEventListener('scroll', this.Scrollbottom) //页面离开后销毁监听事件
	},
    mounted() {
        let user_data = JSON.parse(localStorage.getItem('user_data'))
        this.user_id = user_data.id
        this.getData()
    },
    methods: {
		// 触底函数
		Scrollbottom() {
			let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
			let clientHeight = document.documentElement.clientHeight;
			let scrollHeight = document.documentElement.scrollHeight;
			if (scrollTop + clientHeight >= scrollHeight) {
				// console.log("滚动到底部了")
				if(this.is_pages){
					this.getData()
				}
			}
		},
		// 文件下载
		word_down(id){
			let param = {
			    user_id: this.user_id,
			    order_id: id,
			}
			let sing = encryption.getSing(param)
			
			var _this = this
			this.$api.get_worddown(param,sing).then((res) => {
				if(res.data.code == 1){
					_this.downloadUrl = res.data.data;
					setTimeout(function(){
						_this.$refs.downloadUrl.dispatchEvent(new MouseEvent('click'))
					},100)
				}
			})
		},
        //分页
        handleCurrentChange(val) {
            this.current_page = val
            this.getData()
        },
        getData() {
            let param = {
                user_id: this.user_id,
                type: this.type,
                p:this.current_page
            }
            let sing = encryption.getSing(param)
			this.$api.order_list(param,sing).then((res) => {
				if (res.data.code == 1) {
					res.data.data.list.forEach(item=>{
						item.add_time = this.$common.timetrans(item.add_time,true,'-','-','')
						if(item.order_status ==0 || item.order_status ==1 || item.order_status ==2 || item.order_status ==3 ){
							// 待报价
							item.order_status = this.$t('m.Myorder_14')
						}else if(item.order_status ==6 || item.order_status ==5 || item.order_status ==4 ){
							// 待付款
							item.order_status = this.$t('m.Myorder_15')
						}else if(item.order_status ==7 && (item.shipping_status == 0 || item.shipping_status == 2)){
							// 待发货
							item.order_status = this.$t('m.Myorder_16')
						}else if(item.order_status ==7 && (item.shipping_status == 1)){
							// 待收货
							item.order_status = this.$t('m.Myorder_17')
						}else if(item.order_status ==8){
							item.order_status = this.$t('m.Myorder_18')
						}else if(item.order_status ==9){
							item.order_status = this.$t('m.Myorder_19')
						}
					})
					console.log('res.data.list',res.data.data.list)
					this.total = res.data.data.count
					// 判断显示屏宽
					var is_h5 = document.documentElement.clientWidth || document.body.clientHeight;
					if(is_h5>1200){
						// PC
						this.tableData = res.data.data.list || []
					}else{
						// H5
						if(res.data.data.list.length){
							this.current_page++
							if(this.current_page == 1){
								this.tableData = res.data.data.list
							}else{
								this.tableData = this.tableData.concat(res.data.data.list)
							}
						}else{
							this.is_pages = false
						}
					}
				}
			})
        },
        chang_nav(index) {
            this.nav_list.forEach(item => {
                item.Selected = false
            });
            this.nav_list[index].Selected = true
            this.type = this.nav_list[index].id
            this.current_page = 1
            this.getData()
			
			
        },
        //查看详情
        order_info(id) {
            this.$router.push({
                path: './order_info?order_id='+id
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.user_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-left: 5px solid #ef5843;
    height: 26px;
    padding-right: 30px;
    padding-left: 20px;
    .user_box_left {
        padding-left: 25px;
    }
}
.search {
    margin-top: 30px;
    width: 100%;
    padding: 0 50px;
}
.tableDatabox {
    padding: 0 50px;
    margin-top: 20px;
}
.nav_box {
    margin-top: 25px;
    display: flex;
    width: 100%;
    align-items: center;
    padding: 0 50px;
    .nav_li {
        margin-right: 30px;
        font-weight: bold;
        font-size: 15px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
        .Underline {
            width: 16px;
            height: 4px;
            background-color: #ef5843;
            margin-top: 2px;
        }
    }
    .Selected_style {
        color: #ef5843;
    }
}
.pagingbox {
    padding: 0 30px;
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
::v-deep.el-table th.el-table__cell {
    background-color: #ef5843;
    color: #fff;
}
.el-table ::v-deep.el-table__cell {
    text-align: center;
}
.pointer {
    display: flex;
    align-items: center;

    .info {
        color: #ef5843;
    }

    .download {
        color: #0c63fc;
    }

    .line {
        padding: 0 6px;
    }
}
.operation {
    display: flex;
    justify-content: center;
}
::v-deep .el-table th.el-table__cell>.cell {
    color: #fff;
}
::v-deep .el-table__header {
    height: 50px !important;
}




.tableDatabox_h5{display: none;}
// 宽度小于1200px
@media screen and (max-width: 1200px){
	.info {
	        color: #ef5843;
	    }
	
	    .download {
	        color: #0c63fc;
	    }
	
	    .line {
	        padding: 0 6px;
	    }
	
	.user_box_left{
		padding-left: 0!important;
	}
	.nav_box{
		padding: 0 0.8rem;
		margin-top: 0.5rem;
		align-items: center;
		display:block;
		// white-space: nowrap;
		// overflow: scroll;
		// &::-webkit-scrollbar{display: none;}
		.nav_li{
			display: inline-block;
			height: auto;
			// margin-bottom: 0.1rem;
			padding: 0.2rem 0;
			.Underline{
				width: 100%;
				
			}
		}
	}
	.tableDatabox{
		padding: 0;
		display: none;
	}
	.tableDatabox_h5{
		display: block;
		padding: 0 0.8rem;
		.zw{
			margin-top: 0.875rem;
			text-align: center;
			border-top: 0.025rem solid #dddddd;
			padding-top: 0.8rem;
		}
		.other_box{
			// margin-top: 20px;
			background: #fff;
			margin: auto;
			margin-top: 0.875rem;
			padding-top: 0;
			.tit{
				font-size: 0.9rem;
				font-weight: 600;
				// padding: 0.6rem 0rem;
				border-bottom: 0.025rem solid #dddddd;
			} 
			.status{
				margin-top: 0.5rem;
				p{
					font-size: 0.55rem;
					font-weight: 600;
					color: #ef5843;
				}
			}
			.item_o{
				border-radius: 0.2rem;
				min-height: 5.825rem;
				background: #fff;
				margin: auto;
				padding-top: 0.075rem;
				padding-bottom: 1rem;
				.tips{
					padding-top: 0.9rem;
					padding-bottom: 0.2rem;
					font-size: 0.3rem;
					font-weight: 600;
					&:last-child{
						padding-top: 0.2rem;
					}
					input{
						width: 85%;
						text-align: right;
						font-size: 0.6rem;
						&::placeholder{
							color: #b9babb;
						}
					}
				}
				.goods{
					margin-top: 0.5rem;
					.l{
						width: 4.175rem;
						height: 3.95rem;
						margin-right: 0.6rem;
						img{
							width: 4.175rem;
							height: 3.95rem;
							border-radius: 0.2rem;
						}
					}
					.r{
						width: calc(100% - 3.775rem);
						.tbox1{
							p{
								font-size: 0.70rem;
								font-weight: 600;
							}
						}
						.tbox2{
							margin-top: 0.4rem;
							p{
								font-size: 0.6rem;
								color: #7d7d89;
							}
						}
					}
				}
			}
			.item{
				margin-bottom: 0.275rem;
				p{
					font-size: 0.6rem;
					&:first-child{
						width: 35%;
						font-size: 0.6rem;
						font-weight: 600;
					}
					&:last-child{
						width: 65%;
						text-align: right;
					}
				}
			}
			.ggbox{
				background: rgba(233, 236, 242, 0.4);
				padding:  0.8rem 0.5rem;
				margin-top: 1rem;
				border-radius: 0.2rem;
				.tit2{
					font-size: 0.9rem;
					font-weight: 600;
					padding: 0.6rem 0rem;
				} 
				.gg_box{
					padding: 0.2rem 0;
					.item_gg1{
						padding: 0.5rem 0;
						font-size: 0.6rem;
						text-align: center;
						div{
							display: flex;
							align-items: center;
							justify-content: center;
							border-radius: 50%;
							width: 1rem;
							height: 1rem;
							background: #ecedf0;
							margin-right: 1rem;
							img{
								width: 0.5rem;
								height: 0.5rem;
							}
						}
						.active{
							background: #ef5843;
						}
					}
					.item_gg2{
						padding: 0.5rem 0;
						div{
							display: flex;
							align-items: center;
							justify-content: center;
							.btnbox {
							    border-radius: 3px;
							    border: 2px solid #e5e5e5;
							    width: 40px;
							    height: 24px;
							    line-height: 24px;
							    font-weight: bold;
							}
							.inpunumber {
							    ::v-deep .el-input__inner {
							        border: 0 !important;
							        padding: 0 !important;
							        width: 30px;
							        text-align: center;
									background: none;
							    }
							}
						}
						p{
							font-size: 0.6rem;
							text-align: center;
							width: calc(100%/3);
						}
					}
				}
			}
	
		}
	}
	.pagingbox{
		display: none;
	}
}

</style>